// @greenlight-spec: 57-screenshot-walkthroughs.md, 28-it-dashboard-ui.md
import boxCcgApp from '../../public/walkthroughs/box-ccg-app/walkthrough.json';
import entraGraphAppOnlyRegistration from '../../public/walkthroughs/entra-graph-app-only-registration/walkthrough.json';
import entraGraphDelegatedRegistration from '../../public/walkthroughs/entra-graph-delegated-registration/walkthrough.json';
import entraTeamsAppRegistration from '../../public/walkthroughs/entra-teams-app-registration/walkthrough.json';
import githubAppRegistration from '../../public/walkthroughs/github-app-registration/walkthrough.json';
import salesforceExternalClientApp from '../../public/walkthroughs/salesforce-external-client-app/walkthrough.json';
import snowflakeOauthIntegration from '../../public/walkthroughs/snowflake-oauth-integration/walkthrough.json';
import { walkthroughSchema, type Walkthrough, type WalkthroughInput } from './schema';

/**
 * Every walkthrough the dashboard renders, by id. A manifest joins by being
 * imported here; `public/walkthroughs/README.md` describes the folder.
 */
const manifests: readonly WalkthroughInput[] = [
  boxCcgApp as WalkthroughInput,
  entraGraphAppOnlyRegistration as WalkthroughInput,
  entraGraphDelegatedRegistration as WalkthroughInput,
  entraTeamsAppRegistration as WalkthroughInput,
  githubAppRegistration as WalkthroughInput,
  salesforceExternalClientApp as WalkthroughInput,
  snowflakeOauthIntegration as WalkthroughInput,
];

export function buildRegistry(
  inputs: readonly WalkthroughInput[],
): ReadonlyMap<string, Walkthrough> {
  return new Map(
    inputs.map((manifest) => {
      const parsed = walkthroughSchema.parse(manifest);
      return [parsed.id, parsed];
    }),
  );
}

export const walkthroughs: ReadonlyMap<string, Walkthrough> = buildRegistry(manifests);

export { walkthroughSchema, type Walkthrough, type WalkthroughStep } from './schema';
